import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex flex-column text-white" }
const _hoisted_2 = { class: "item-body item-bold text-white" }
const _hoisted_3 = { class: "item-body text-white" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-column item-body text-white pt-2"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_7 = { class: "d-flex flex-column pt-3" }
const _hoisted_8 = { class: "item-body item-bold text-white" }
const _hoisted_9 = { class: "item-body text-white" }
const _hoisted_10 = { class: "d-flex flex-column pt-3" }
const _hoisted_11 = { class: "item-body item-bold text-white" }
const _hoisted_12 = { class: "item-body text-white" }
const _hoisted_13 = { class: "table table-borderless text-white p-3 mb-0" }
const _hoisted_14 = {
  scope: "col",
  class: "item-body item-bold text-white ps-3"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-end item-body item-bold text-white"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-end item-body item-bold text-white pe-4"
}
const _hoisted_17 = {
  style: {"width":"50%"},
  class: "item-body text-white ps-3"
}
const _hoisted_18 = {
  key: 0,
  class: "pt-2 text-white item-body-small"
}
const _hoisted_19 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_20 = { class: "text-end item-body text-white" }
const _hoisted_21 = { class: "text-end item-body text-white pe-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isMobileScreen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["text-white px-3", _ctx.isDarkBlue ? 'bg-dark-blue' : ''])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "py-3",
              style: _normalizeStyle(index > 0 ? 'border-top: 1px solid white' : '')
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.productTitle), 1),
                _createElementVNode("span", _hoisted_3, [
                  _createTextVNode(_toDisplayString(item.productName) + " ", 1),
                  _hoisted_4
                ]),
                (item.productDetailTitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", null, _toDisplayString(item.productDetailTitle), 1),
                      (item.productDetails)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.productDetails, (productDetail, productDetailIndex) => {
                              return (_openBlock(), _createElementBlock("div", { key: productDetailIndex }, " -" + _toDisplayString(productDetail), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.coverAmountTitle), 1),
                _createElementVNode("span", _hoisted_9, " $" + _toDisplayString(item.coverAmount.toLocaleString()), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.premiumAmountTitle), 1),
                _createElementVNode("span", _hoisted_12, " $" + _toDisplayString(item.premiumAmount.toFixed(2)), 1)
              ])
            ], 4))
          }), 128))
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.isMobileScreen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["py-3", _ctx.isDarkBlue ? 'bg-dark-blue' : ''])
        }, [
          _createElementVNode("table", _hoisted_13, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.productTitle), 1),
                _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.coverAmountTitle), 1),
                _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.premiumAmountTitle), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("div", null, _toDisplayString(item.productName), 1),
                    (item.productDetailTitle)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(item.productDetailTitle), 1))
                      : _createCommentVNode("", true),
                    (item.productDetails)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.productDetails, (productDetail, productDetailIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: productDetailIndex,
                              class: "text-white item-body-small"
                            }, " -" + _toDisplayString(productDetail), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_20, "$" + _toDisplayString(item.coverAmount.toLocaleString()), 1),
                  _createElementVNode("td", _hoisted_21, "$" + _toDisplayString(item.premiumAmount.toFixed(2)), 1)
                ]))
              }), 128))
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}